import * as Core from '@skylab-shared/core';
import { PurchaseDocumentKind } from './purchase-document-kind';


export class PurchaseKindModel extends Core.ModelBase {
    @Core.Property()
    public adjustment: boolean;

    @Core.Property()
    public defaultCalculationMethod: string;

    @Core.Property()
    public defaultNumberingId: number;

    @Core.Property({ identifiable: true })
    public name: PurchaseDocumentKind;

    @Core.Property()
    @Core.Range({ min: 0 }, 'data-model.document-configuration.validation.default-due-date.range')
    public defaultDueDate: number;

}
